module.exports = __webpack_public_path__ + "static/media/card-Charlie.81f89d5a.svg";